import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import AuthSkeleton from "./AuthSkeleton";

import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { selectAuth } from "./authSlice";

import { changePageTitle } from "../preferences/preferencesSlice";
import AccountHeader from "../../components/account/AccountHeader";
import ChangePassword from "../../components/account/ChangePassword";
import Container from "@mui/material/Container";
import { CompanyDetail } from "../../components/account/CompanyDetail";
import { SubAgentsEntry } from "../setups/SubAgentsEntry";
import { getCompany, selectSetups } from "../setups/setupSlices";

export const Profile = () => {
  const { loading, user } = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();
  const [isSudan, setIsSudan] = useState(false);

  const title = "My Account";
  useEffect(() => {
    dispatch(changePageTitle(title));
  }, [dispatch]);

  const { selectedCompany: companyProfile } = useAppSelector(selectSetups);
  useEffect(() => {
    if (user && user.company) {
      if (user.company._id) {
        const companyId = user.company?._id as string;
        if (companyId && companyId.length > 0) {
          dispatch(getCompany(companyId as string));
        }
      }
      if (
        user.company.depositAmount &&
        user.company.depositAmount === "sudan"
      ) {
        setIsSudan(true);
      } else setIsSudan(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <div>
      <Helmet>
        <title>{title} | EnjazPlus</title>
      </Helmet>
      <Container maxWidth="lg">
        <Box sx={{ mt: 2 }} />
        <Box
          sx={{
            backgroundColor: "background.default",
            minHeight: "100%",
            py: 3,
          }}
        >
          {loading === "pending" ? (
            <AuthSkeleton />
          ) : (
            <Box sx={{ p: 2 }}>
              <Grid container spacing={3}>
                <Grid item lg={4} md={5} xs={12}>
                  <AccountHeader />
                </Grid>
                <Grid item lg={8} md={7} xs={12}>
                  {/* <AccountDetail /> */}
                  <CompanyDetail />
                </Grid>
              </Grid>
              {isSudan && (
                <Box sx={{ pt: 3 }}>
                  <SubAgentsEntry companyId={companyProfile._id} />
                </Box>
              )}
              <Box sx={{ pt: 3 }}>
                <ChangePassword />
              </Box>
            </Box>
          )}
        </Box>
      </Container>
    </div>
  );
};
